/**
 * @typedef {object} StorageLens An object who provides a getter and a setter of
 * a whole storage based on another. Example: the data structure (key/value)
 * that is in the entry 'searchData' in LocalStorage (storage-in-storage model)
 * @property {function(Storage):Storage} get Get the storage from a given
 * high-order storage
 * @property {function(Storage, Storage):Storage} set Set the storage into the
 * high-order storage
 */

/**
 * Create a Lens of an Storage
 * @param {function(Storage):Storage} getter getter function
 * @param {function(Storage, Storage):Storage} setter setter function
 * @returns {StorageLens} The lens
 */
function createStorageLens(
  getter, // (innerStorage) => storage
  setter // (storage, innerStorage) => storage
) {
  return {
    get: getter,
    set: setter,
  };
}

module.exports = createStorageLens;
